<template>
  <div>
    <OnboardingIndex
      :title="title"
      :submit_button_text="submitButtonText"
      :verification_running="verification_running"
      :custom_submit_button="true"
      @custom-submit="signup_function"
    >
      <template v-slot:form-content>
        <div class="mx-auto w-100">
          <div class="mb-3">
            <label for="organization_name" class="text-xs mb-2">Organization Name</label>
            <input
              id="organization_name"
              v-model="form.organization_name"
              type="text"
              class="form-control form-control-sm text-xs bg-light border-0 py-2"
              placeholder="Enter organization name"
              required
            />
          </div>

          <div class="row g-2">
            <div class="col-12 col-md-6">
              <label for="first_name" class="text-xs mb-2">First Name</label>
              <input
                id="first_name"
                v-model="form.first_name"
                type="text"
                class="form-control form-control-sm text-xs bg-light border-0 py-2"
                placeholder="First name"
                required
              />
            </div>
            <div class="col-12 col-md-6">
              <label for="last_name" class="text-xs mb-2">Last Name</label>
              <input
                id="last_name"
                v-model="form.last_name"
                type="text"
                class="form-control form-control-sm text-xs bg-light border-0 py-2"
                placeholder="Last name"
                required
              />
            </div>
          </div>

          <div class="my-3">
            <label for="signup_email" class="text-xs mb-2">Admin Email</label>
            <input
              id="signup_email"
              v-model="form.email"
              type="email"
              class="form-control form-control-sm text-xs bg-light border-0 py-2"
              placeholder="admin@example.com"
              required
            />
          </div>

          <div class="mb-3">
            <label for="signup_password" class="text-xs mb-2">Password</label>
            <div class="position-relative">
              <input
                id="signup_password"
                v-model="form.password"
                :type="show_password ? 'text' : 'password'"
                class="form-control form-control-sm text-xs bg-light border-0 py-2 pe-5"
                placeholder="Create a password"
                required
              />
              <i
                class="position-absolute end-0 top-50 translate-middle-y me-3 text-secondary cursor-pointer z-2"
                role="button"
                tabindex="0"
                @click="toggle_password_visibility"
                @keydown.enter.prevent="toggle_password_visibility"
                @keydown.space.prevent="toggle_password_visibility"
                :aria-label="show_password ? 'Hide password' : 'Show password'"
                :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
              ></i>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center gap-2">
            <router-link to="/" class="fw-semibold text-decoration-none small text-xs">
              Existing organization? Sign in with your admin email
            </router-link>
          </div>
        </div>
      </template>

      <template v-slot:custom-button>
        <div class="d-grid pt-1">
          <button
            type="submit"
            class="btn btn-primary-dark shadow w-100"
            :disabled="verification_running"
          >
            {{ submitButtonText }}
          </button>
        </div>
      </template>
    </OnboardingIndex>
  </div>
</template>
